/* istanbul ignore next */
export default id => typeof document !== 'undefined' ? document.getElementById(id) : null;
//# sourceMappingURL=get-element-by-id.js.map